// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {mantineFlexWrapSchema} from "./primitives.zod";
import {mantineSpacingSchema} from "./spacing.zod";

export const mantineFlexPropsSchema = z.strictObject({
	justify: z.string().optional(),
	align: z.string().optional(),
	gap: mantineSpacingSchema.optional(),
	wrap: mantineFlexWrapSchema.optional(),
	direction: z
		.union([
			z.literal("row"),
			z.literal("column"),
			z.literal("row-reverse"),
			z.literal("column-reverse"),
			z.object({
				base: z
					.union([
						z.literal("row"),
						z.literal("column"),
						z.literal("row-reverse"),
						z.literal("column-reverse"),
					])
					.optional(),
				xs: z
					.union([
						z.literal("row"),
						z.literal("column"),
						z.literal("row-reverse"),
						z.literal("column-reverse"),
					])
					.optional(),
				sm: z
					.union([
						z.literal("row"),
						z.literal("column"),
						z.literal("row-reverse"),
						z.literal("column-reverse"),
					])
					.optional(),
				md: z
					.union([
						z.literal("row"),
						z.literal("column"),
						z.literal("row-reverse"),
						z.literal("column-reverse"),
					])
					.optional(),
				lg: z
					.union([
						z.literal("row"),
						z.literal("column"),
						z.literal("row-reverse"),
						z.literal("column-reverse"),
					])
					.optional(),
				xl: z
					.union([
						z.literal("row"),
						z.literal("column"),
						z.literal("row-reverse"),
						z.literal("column-reverse"),
					])
					.optional(),
			}),
		])
		.optional(),
});
